import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

export default function Breadcrumbs({ items }) {
  if (!items || items.length === 0) return null;

  return (
    <nav aria-label="Breadcrumb" className="mb-4">
      <ol className="flex flex-wrap items-center gap-1 text-sm text-slate-400">
        {/* Home is always first */}
        <li className="flex items-center">
          <Link 
            to="/" 
            className="flex items-center gap-1 hover:text-indigo-400 transition-colors"
          >
            <Home className="h-3.5 w-3.5" />
            <span className="hidden sm:inline">Home</span>
          </Link>
        </li>
        
        {items.map((item, index) => (
          <li key={index} className="flex items-center">
            <ChevronRight className="h-3.5 w-3.5 mx-1 text-slate-600" />
            {index === items.length - 1 ? (
              // Last item - no link, current page
              <span className="text-slate-300 truncate max-w-[200px] sm:max-w-[300px]">
                {item.name}
              </span>
            ) : (
              // Intermediate items - with links
              <Link 
                to={item.url} 
                className="hover:text-indigo-400 transition-colors truncate max-w-[150px]"
              >
                {item.name}
              </Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
